import { PresencasResponse } from 'api/Assessor/evento';

interface QuorumState {
  agencia: string[];
  quorumAtingidoOrRepresentados: string;
  flgTodos: string;
  nucleo: string[];
  loading: boolean;
  page: number;
  size: number;
  loadingTotais: boolean;
  totais: PresencasResponse | null;
  needReloadTable: boolean;
}

type QuorumActionTypes =
  | 'setSize'
  | 'setFiltros'
  | 'setPaginacao'
  | 'setLoading'
  | 'setAGOData'
  | 'setAGNData'
  | 'setQuorumType'
  | 'setLoadingTotais'
  | 'setTotais'
  | 'setReloadTable';

interface QuorumAction {
  type: QuorumActionTypes;
  value: any;
}

export const QuorumInitialState: QuorumState = {
  agencia: [],
  quorumAtingidoOrRepresentados: 'Quórum atingido',
  flgTodos: 'Todos',
  nucleo: [],
  loading: false,
  page: 1,
  size: 10,
  loadingTotais: false,
  totais: null,
  needReloadTable: false,
};

export const QuorumReducer = (
  state: QuorumState,
  action: QuorumAction
): QuorumState => {
  switch (action.type) {
    case 'setFiltros':
    case 'setPaginacao':
      return { ...state, ...action.value };
    case 'setSize':
      return { ...state, size: action.value };
    case 'setLoading':
      return { ...state, loading: action.value };
    case 'setLoadingTotais':
      return { ...state, loadingTotais: action.value };
    case 'setQuorumType':
      return { ...state, quorumAtingidoOrRepresentados: action.value };
    case 'setTotais':
      return { ...state, totais: action.value };
    case 'setReloadTable':
      return { ...state, needReloadTable: action.value };
    default:
      return state;
  }
};
